<template>
    <div v-if="this.utilityData.hasOwnProperty('u_idx')">
        <div class="container-utility-detail">
            <!-- <div class="thumbnail-utility-detail" :style="`background-image : url('${returnImg(this.utilityData.UtilityImg[0])}')`"></div> -->
            <div class="nticket-bg-color">
                <div class="wrap-nticket-common">
                    <ticket-image
                        :svgWidth="ticketWidth"
                        :ticketLeftColor="'#007B94'"
                        :ticketRightColor="'#FFF'"
                    ></ticket-image>
                    <div class="category-nticket-common">
                        <div class="text-category-nticket">교환권</div> <!-- TODO 데이터로 변경 -->
                    </div>
                    <div class="info-nticket-common">
                        <div class="fg-1 pl10 pr10 of-hidden">
                            <div class="pb4 fz15 fw500 one-ellipsis zoom-common">수정해야 할 입장권</div> <!-- TODO 데이터로 변경 -->
                            <div class="box-flex pb10">
                                <div class="icon-mingle-utility"></div>
                                <div class="fz13 fw700 c33 one-ellipsis zoom-common">50,000 Mg</div> <!-- TODO 데이터로 변경 -->
                                <div class="fz11 c80 pl3 one-ellipsis zoom-common">(￦ 0)</div> <!-- TODO 데이터로 변경 -->
                            </div>
                            <div class="box-flex f-wrap zoom-common">
                                <div class="icon-nticket-share main-icon"></div>
                                <div class="fz11 fw500 c66 pl4 pr3">{{ $t('other', {data: 'data'}) }}</div>
                                <!-- TODO 데이터로 변경 -->
                                <div class="box-flex">
                                    <!-- TODO 데이터로 변경 -->
                                    <div class="box-flex pl6 zoom-common">
                                        <div class="icon-nticket-share"></div>
                                        <div class="icon-nticket-share"></div>
                                        <div class="icon-nticket-share"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="image-nticket-common" :style="`background-image : url('${returnImg(data.collectionImg[0])}')`"> -->
                        <div class="image-nticket-common" :style="`background-color : red`"> <!-- TODO 데이터로 변경 -->
                            <div class="box-image-nticket">
                                <div class="icon-12-common heart"></div>
                                <div class="pl2 fz12 fw500 c80">999+</div> <!-- TODO 데이터로 변경 -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pl13 pr13">
                <div class="box-flex j-between pt20 pb16">
                    <!-- <div class="icon-collection-utiltity" :style="`background-image : url('${returnImg(this.utilityData.collectionImg[0])}')`"></div> -->
                    <div class="fz20 fw700 c00">{{ this.utilityData.c_title }}</div>
                    <div class="nticket-category-border">카테고리명</div> <!-- TODO 데이터로 변경 -->
                </div>
                <div class="box-user-utility">
                    <div class="icon-director-utility"
                         :style="`background-image : url('${returnImg(this.utilityData.directorProfile[0])}')`"></div>
                    <div class="name-director-utility">{{ this.utilityData.director_nick }}</div>
                </div>
                <!-- <div class="title-product-nticket">{{ this.utilityData.child_uc_name }}</div> -->
                <!-- <div class="content-product-nticket">{{ this.utilityData.u_name }}</div> -->
                <div class="caution-utility-detail">
                    {{ this.utilityData.u_detail }}
                </div>
                <div class="wrap-date-utility">
                    <div class="box-date-utility" v-if="!showSellCountdown(2)">
                        <div class="title-date-utility">{{ $t('sell_time') }}</div>
                        <div class="period-date-utility">
                            <div class="dis-ib">
                                {{ returnDateFormat(this.utilityData.u_sell_start_date, "YYYY-MM-DD HH:MM") }}
                            </div>
                            <div class="dis-ib">

                                ~{{ returnDateFormat(this.utilityData.u_sell_end_date, "YYYY-MM-DD HH:MM") }}
                            </div>
                        </div>


                    </div>
                    <div class="box-date-utility">
                        <div class="title-date-utility">{{ $t('using_time') }}</div>
                        <div>
                            <div class="period-date-utility pb8">
                                <div class="dis-ib">
                                    {{ returnDateFormat(this.utilityData.u_use_start_date, "YYYY-MM-DD HH:MM") }}
                                </div>
                                <div class="dis-ib">

                                    ~{{ returnDateFormat(this.utilityData.u_use_end_date, "YYYY-MM-DD HH:MM") }}
                                </div>
                            </div>
                            <div class="icon-division-utuility" v-if="showSellCountdown(2)"
                                 :class="returnState(this.utilityData.u_is_use, this.utilityData.u_use_start_date, this.utilityData.u_use_end_date)">
                                {{
                                    $t(returnStateText(this.utilityData.u_is_use, this.utilityData.u_use_start_date, this.utilityData.u_use_end_date))
                                }}
                            </div>
                        </div>

                    </div>
                    <div class="box-date-utility">
                        <div class="title-date-utility">{{ $t('using_cnt') }}</div>
                        <div class="period-date-utility">
                            <span class="use">{{ this.utilityData.u_use_total }} / </span>
                            <span>{{ this.utilityData.u_use_total }}</span></div>
                    </div>
                    <div class="box-date-utility"
                         v-if="returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === 2">
                        <div class="title-date-utility">{{ $t('total_cnt') }}</div>
                        <div class="period-date-utility"><span>{{
                                returnTotal(this.utilityData.u_publish_total)
                            }}</span></div>
                    </div>
                    <div class="box-date-utility">
                        <div class="title-date-utility">{{ $t('collection') }}</div>
                        <div class="box-flex f-wrap fg-0">
                            <div class="icon-nticket-share main-icon size22"></div>
                            <div class="fz14 fw400 c4d pl4 pr3">{{ $t('other_things', {data: 'data'}) }}</div>
                            <!-- TODO 데이터로 변경 -->

                            <div class="box-flex a-center">
                                <div class="box-flex pl6 mr4" :style="`width: ${16 * 3 + 6}px`">
                                    <div class="icon-nticket-share size22"></div>
                                    <div class="icon-nticket-share size22"></div>
                                    <div class="icon-nticket-share size22"></div>
                                </div>
                                <div class="fz14 fw400 c4d pr4">{{ $t('numbering_collection', {count: '5'}) }}</div>
                            </div>
                            <!-- TODO 데이터로 변경 -->


                        </div>
                        <div class="icon-arrow-utility fs-0 mt4"></div>
                    </div>
                </div>
                <!-- 이전 퍼센트 디자인 -->
                <!-- <div class="box-date-utility" v-if="showSellPercentage()"> 
                    <div class="title-date-utility">{{$t('total_count')}}</div>
                    <div class="period-date-utility"><span>{{ this.utilityData.selled_cnt }}</span> /
                        {{ this.utilityData.u_publish_total }}
                    </div>
                </div>
                <div class="box-percent-utility" v-if="showSellPercentage()">
                    <div class="filled-percent-utility" :style="`width: ${returnPercent(this.utilityData.selled_cnt?this.utilityData.selled_cnt:0  , this.utilityData.u_publish_total)}%`"></div>
                </div> -->

                <!-- 변경된 퍼센트 디자인 -->
                <div class=""> <!-- TODO showSellPercentage() 추가 해야함 -->
                    <div class="fz15 fw500 color-common pb8">
                        {{
                            $t('counts_publication', {count: `${this.utilityData.selled_cnt}/${this.utilityData.u_publish_total}`})
                        }}
                    </div>
                    <div class="wrap-progress-nticket">
                        <div class="progress-nticket" :style="`width: 50%`"></div>
                        <div class="inner-progress-nticket"></div>
                        <div class="inner-progress-nticket"></div>
                        <div class="inner-progress-nticket"></div>
                        <div class="inner-progress-nticket"></div>
                    </div>
                </div>
                <!-- <div class="box-countdown-utility" v-if="(showSellCountdown(0) || showSellCountdown(1))">
                    <div class="title-countdown-utility" v-html="$t(returnTimeText())"></div>
                    <div class="counts-countdown-utility"
                        id="countdown">{{ this.countdown }}
                    </div>
                    <div class="date-countdown-utility">
                        <div class="pr32">{{ $t(returnSellText()) }}</div>
                        <div>{{ returnDotDateTime(returnTime()) }}</div>
                    </div>
                </div> -->
                <div class="box-flex j-between a-start">
                    <div class="fz15 fw500 c33">{{ $t('sell_off_left_times') }}</div>
                    <div class="ta-right">
                        <div class="fz18 fw700 color-common">5일 21시간 23분 12초</div>
                        <div class="fz13 fw400 c66 pt4">2024.05.03 12:00 종료</div>
                    </div>
                </div>
                <!-- <div class="box-cost-common mb12" v-if="!showSellCountdown(2)"> -->
                <div class="box-cost-common mb0 mt32">
                    <div class="info-cost-common">{{ $t('n_buy') }}</div>
                    <div>
                        <div>
                            <div class="icon-common size18"></div>
                            <div class="text-cost-common">{{ this.utilityData.u_price }} Mg</div>
                        </div>
                        <div class="won-cost-common">{{ returnMingle(this.utilityData.u_price) }}
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="footer-utility">
            <!-- <div class="btn-common disabled">판매대기</div> -->
            <button class="btn-common" @click="moveApp()">{{ $t('move_mingle_pass') }}</button>
        </div>
    </div>
</template>


<script>
import alertMixin from "@/mixins/alertMixins";
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import priceMixins from "@/mixins/priceMixins";
import TicketImage from "@/components/element/TicketImage.vue";

export default {
    name: "UtilityDetailLayout",
    mixins: [alertMixin, dateMixins, priceMixins],
    components: {
        TicketImage,
    },
    props: {
        utilityData: {},
    },
    data() {
        return {
            countdown: '',
            ticketWidth: window.innerWidth - 32,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        if (!util.isEmpty(this.utilityData) && (this.showSellCountdown(0) || this.showSellCountdown(1))) {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) == 0) {
                this.intervalId = setInterval(() => {
                    this.countdown = this.getDifferenceDday(this.utilityData.u_sell_start_date)
                }, 1000);
            } else if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) == 1) {
                this.intervalId = setInterval(() => {
                    this.countdown = this.getDifferenceDday(this.utilityData.u_sell_end_date)
                }, 1000);
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnImg(data) {
            if (!util.isEmpty(data)) {
                return data.org_url;
            } else {
                return '';
            }
        },

        returnState(state, start, end) {
            let now = this.returnDateTime(new Date());

            if (state == 1) {
                if (start > now) {
                    return 'waiting'; // 사용대기
                } else if (start < now && end > now) {
                    return 'possible'; // 사용가능
                } else if (end < now) {
                    return 'already'; //기한만료
                }
            } else {
                return 'used'; // 사용완료
            }
        },
        returnStateText(state, start, end) {
            let now = this.returnDateTime(new Date());

            if (state == 1) {
                if (start > now) {
                    return 'use_await'; // 사용대기
                } else if (start < now && end > now) {
                    return 'use_possible'; // 사용가능
                } else if (end < now) {
                    return 'use_end_already'; //기한만료
                }
            } else {
                return 'use_fin'; // 사용완료
            }
        },
        returnTotal(value) {
            if (value === 0) {
                return 0;
            } else {
                return value;
            }
        },
        returnSellState(start, end) {
            let now = this.returnDateTime(new Date());

            if (start > now) {
                return 0; //판매대기
            } else if (start < now && end > now) {
                return 1; //판매중
            } else if (end < now) {
                return 2; //판매종료
            }
        },
        returnPercent(value, max) {
            if (!util.isEmpty(value) && !util.isEmpty(max)) {
                return (value / max) * 100;
            }
        },
        returnTimeText() {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === 0) {
                return 'sell_left_times'
            } else if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === 1) {
                return 'sell_off_left_times'
            }
        },
        returnTime() {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === 0) {
                return this.utilityData.u_sell_start_date
            } else if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === 1) {
                return this.utilityData.u_sell_end_date
            }
        },
        returnSellText() {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) == 0) {
                return 'sell_start_time'
            } else if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) == 1) {
                return 'sell_off_start_time'
            }
        },
        showSellCountdown(value) {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) === value) {
                return true
            } else {
                return false;
            }
        },
        showSellPercentage() {
            if (this.returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) == 2) {
                return false
            }
            return true;
        },
        moveApp() {
            location.href = "https://minglepass.page.link/6BG2";
        }
    },
    watch: {},
}
</script>
